angular.module('CarsSaraBo').factory('CFAService', ['$resource', function($resource) {
  return $resource('/../rest/cfa/',
  	{ country : '@country' , code: '@code'},
    {
      zipcodes : { method : 'GET', url: '../rest/cfa/zipcode'}  }
	)}
]);


//////////////////
// WEBPACK FOOTER
// ./public/app/models/cfa_service.js
// module id = 840
// module chunks = 3